import { getAssets } from "../services/apiDomainAssets";
import { getResponseData } from "./response";
import { useMappedQuery } from "./queryUtils";

export function useAssets() {
  const { isLoading, data, error, isError } = useMappedQuery({
    queryKey: ["logo"],
    queryFn: getAssets,
    retry: false,
  });
  const responseData = getResponseData(data, {});
  const icon = responseData?.fav_icon;
  const logo = responseData?.tenant_logo;
  const {
    company_name = "",
    daily_worklog_reminder = false,
  } = responseData;

  return {
    isLoading,
    error,
    icon,
    isError,
    logo,
    company_name,
    daily_worklog_reminder,
  };
}
